import BusinessPartners from './views/BusinessPartners.vue';
import Contact from './views/Contact.vue';
import BuyCar from './views/BuyCar.vue';
import CarFilter from './views/CarFilter.vue';
import CreateAccount from './views/CreateAccount.vue';
import ViewCar from './views/ViewCar.vue';
import Faq from './views/Faq.vue';
import HelloWorld from './views/HelloWorld.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import PreApproval from './views/PreApproval.vue';
import PrivacyNotice from './views/PrivacyNotice.vue';
import QuoteCredit from './views/QuoteCredit.vue';
import QuoteInsurance from './views/QuoteInsurance.vue';
import CreditRequest from './views/CreditRequest.vue';
import QuotationProcess from './views/QuotationProcess';
import TermsAndConditions from './views/TermsAndConditions';
import GrayZone from './views/GrayZone/GrayZone.vue';
import ContratoCredito from './views/Contratos/ContratoCredito.vue';
import pdfGrayZone from './views/GrayZone/pdfGrayZone.vue';
import grayZone from './views/GrayZone/GrayZone.vue';
import SolicitudFondeo from './views/Contratos/fondeo/SolicitudFondeo.vue';
import ContratoExtras from './views/Contratos/ContratoExtras.vue';
import ContratoFactura from './views/Contratos/ContratoFactura.vue';
import ContratoArrendamiento from './views/contratoArrendamiento/ContratoArrendamiento.vue';
import Quotation from './views/GrayZone/Quotation.vue';
import CartaFactura from './views/Documentos_extra/Carta_factura.vue';
import CaratulaCredito from './views/Contratos/CaratulaCredito.vue';
import QuotationPanel from './views/PanelSola/QuotationPanel.vue';
import QuotationSection from './views/GrayZone/QuotationSection.vue';
import CotizacionTradicional from './views/cotizacion/CotizacionTradicional.vue';
import PagareFederatario from './views/contratoArrendamiento/PagareFederatario.vue';
import ContratoEmpleado from './views/ContratosEmpleado/ContratoEmpleado.vue';
import CotizacionEspacial from './views/cotizacion/CotizacionEspacial.vue';
import CartaPoder from './views/Documentos_extra/Carta_Poder.vue';
import PrivacyChatbot from './views/PrivacyChatbot.vue';
import ListaClientes from './views/ControPanel/listaClientes.vue';
import scannerID from './views/Camara/scannerID.vue';

export const routes = [
    { path: '/', name: 'Login', component: Login },
    { path: '/faq', name: 'Faq', component: Faq },
    { path: '/buy-car', name: 'BuyCar', component: BuyCar },
    { path: '/car-filter', name: 'CarFilter', component: CarFilter },
    // { path: '/view-car', name: 'ViewCar', component: ViewCar },
    { path: '/view-car', name: 'ViewCar', component: ViewCar },
    { path: '/contact', name: 'Contact', component: Contact },
    { path: '/privacy-notice', name: 'PrivacyNotice', component: PrivacyNotice },
    { path: '/terms-conditions', name: 'TermsAndConditions', component: TermsAndConditions },
    { path: '/quote-credit', name: 'QuoteCredit', component: QuoteCredit },
    { path: '/quote-insurance', name: 'QuoteInsurance', component: QuoteInsurance },
    { path: '/quotation-process', name: 'QuotationProcess', component: QuotationProcess },
    { path: '/create-account', name: 'CreateAccount', component: CreateAccount },
    //{ path: '/login', name: 'Login', component: Login },
    { path: '/business-partners', name: 'BussinessPartners', component: BusinessPartners },
    { path: '/pre-approval', name: 'PreApproval', component: PreApproval },
    { path: '/credit-request', name: 'CreditRequest', component: CreditRequest },
    { path: '/gray-zone', name: 'GrayZone', component: GrayZone },
    { path: '/ContratoCredito', name: 'contrato', component: ContratoCredito },
    { path: '/pdfGrayZone', name: 'pdfGrayZone', component: pdfGrayZone},
    { path: '/grayZone', name: 'grayZone', component: grayZone},
    { path: '/ContratoExtras', name: 'contratoextras', component: ContratoExtras },
    { path: '/SolicitudFondeo', name: 'SolicitudFondeo', component: SolicitudFondeo},
    { path: '/ContratoFactura', name: 'ContratoFactura', component: ContratoFactura},
    { path: '/ContratoArrendamiento', name: 'contratoArrendamiento', component: ContratoArrendamiento },
    { path: '/Quotation', name: 'quotation', component: Quotation },
    { path: '/Cartafactura', name: 'CartaFactura', component: CartaFactura },
    { path: '/CaratulaCredito', name: 'CaratulaCredito', component: CaratulaCredito },
    { path: '/QuotationPanel', name: 'QuotationPanel', component: QuotationPanel },
    { path: '/QuotationSection', name: 'QuotationSection', component: QuotationSection },
    { path: '/CotizacionTradicional', name: 'CotizacionTradicional', component: CotizacionTradicional },
    { path: '/PagareFederatario', name: 'PagareFederatario', component: PagareFederatario },
    { path: '/ContratoEmpleado', name: 'ContratoEmpleado', component: ContratoEmpleado },
    { path: '/CotizacionEspacial', name: 'CotizacionEspacial', component: CotizacionEspacial },
    { path: '/CartaPoder', name: 'CotizacionEspacial', component: CartaPoder },
    { path: '/PrivacyChatbot', name: 'PrivacyChatbot', component: PrivacyChatbot },
    { path: '/ListaClientes', name: 'ListaCliente', component: ListaClientes },
    { path: '/scannerid', name: 'scannerid', component: scannerID },


    //{ path: '*', redirect: '/' },
];



// WEBPACK FOOTER //
// ./src/routes.js